import $ from 'jquery';
import { injectSection, showSiteDetailMap } from 'map';
import { restoreScrollPos, saveScrollPos, siteFieldSelector, zeroPad } from 'utils';
import debounce from 'debounce';

let sitesCount = 0;

function navigatePanel(index) {
    if (0 <= index && index < sitesCount) {
        const $btnDestination = $(`button[aria-controls='sted${index}']`);
        const currentExpandedState = $btnDestination.attr('aria-expanded');
        if (currentExpandedState === 'true') {
            onOpen($btnDestination);
        } else {
            $btnDestination.click();
        }
    }
}

function prevPanel(event) {
    const index = $(event.target).closest('li').data('index');
    navigatePanel(index - 1);
}

function nextPanel(event) {
    const index = $(event.target).closest('li').data('index');
    navigatePanel(index + 1);
}

function onOpen(btn) {
    const $panel = $(btn).closest('li');
    $panel.find('.visibleState').val('true');
    $panel.find("input[type=text]:not([readonly]), textarea:not([readonly])").first().trigger('focus');
}

function onClose(btn) {
    $(btn).closest('li').find('.visibleState').val('true');
}

$(() => {
    restoreScrollPos();

    // noinspection JSUnresolvedVariable
    sitesCount = $('.sitePanel').length;

    $('.chainageInput').on('change', (event) => {
        const myPanel = $(event.target).closest('.accordion-content');
        const siteIndex = myPanel.data('index');

        const administrativeStreetCode = $(siteFieldSelector('administrativeStreetCode', siteIndex)).val();
        const streetSection = $(siteFieldSelector('streetSection', siteIndex)).val();
        const chainageFromKMT = $(siteFieldSelector('chainage.fromKm', siteIndex)).val() + zeroPad($(siteFieldSelector('chainage.fromM', siteIndex)).val(), 4);
        const chainageToKMT = $(siteFieldSelector('chainage.toKm', siteIndex)).val() + zeroPad($(siteFieldSelector('chainage.toM', siteIndex)).val(), 4);
        const path = `/${administrativeStreetCode}/${streetSection}?from=${chainageFromKMT}&to=${chainageToKMT}`;

        $(`input[name='sted${siteIndex}ReferencingUrl']`).val(path);

        const vdMap = myPanel.data('vdMap');
        vdMap.removeSection();
        // noinspection JSIgnoredPromiseFromCall
        injectSection(path, vdMap);
    });

    $('div.accordion-content').each((_index, element) => {
        if ($(element).attr('aria-hidden') === 'false') {
            // setup if panel is open
            showSiteDetailMap(element);
        } else {
            $(element).prev().children('button').get(0).addEventListener('fds.accordion.open', () => {
                // setup when panel is opened
                showSiteDetailMap(element);
            }, {once: true});
        }
    });

    if (sitesCount > 1) {
        // For more than 1 site, sites are collapsed, so url fragment focus by browser doesn't work
        const match = /mainForm_caseBean_sites_(\d+)_/.exec(window.location.hash);
        if (match) {
            navigatePanel(parseInt(match[1], 10));
            $(window.location.hash).trigger('focus');
        }
    }

    document
        .getElementById('accordion')
        .getElementsByClassName('sitePanel')
        .forEach(button => {
            button.addEventListener('fds.accordion.open', () => onOpen(button));
            button.addEventListener('fds.accordion.close', () => onClose(button));
        });

    $('button[id^=btnprev]').on('click', prevPanel);
    $('button[id^=btnnext]').on('click', nextPanel);

    $(window).on('scroll', debounce(saveScrollPos, 200));
});
